import { httpLocalization } from '@/http';

const baseUrl = 'api';

export default {
  getLanguages() {
    return httpLocalization.get(`${baseUrl}/language/`).then((response) => {
      return response.data;
    });
  },

  getTranslations(lang) {
    return httpLocalization
      .get(`${baseUrl}/translation/?culture_name=${lang}`)
      .then((response) => {
        return response.data;
      });
  },
};
